export default [
  {
    path: '/admin/table-activators',
    name: 'table-activator',
    meta: { requiresAuth: true },
    component: () => import('@/pages/booking/table-activator')
  }
]
